import keyBy from 'lodash/keyBy'
import toArray from 'lodash/toArray'

export const mergeArray = (key, arr1, arr2) => {
  return toArray({
    ...keyBy(arr1, key),
    ...keyBy(arr2, key),
  })
}



// WEBPACK FOOTER //
// ./src/cms/helpers/arrayHelpers.js